/** Ancillary spaces attached to a developer-sale unit (מכר יזם) — a balcony, parking spot, etc. */
export enum AssetAttachmentType {
  Balcony = 'balcony',
  Yard = 'yard',
  Parking = 'parking',
  Storage = 'storage',
  Other = 'other'
}
